module.exports = __webpack_public_path__ + "img/Facebook.50008516.svg";